import { Box } from "@mui/material";
import styled from "styled-components";
import { useOutlet } from "react-router-dom";

const Wrapper = styled(Box)`
  flex-grow: 1;
  padding: 10px;
  margin: 20px 20px 0px;
`;

export default function MainContent() {
  const element = useOutlet();

  return <Wrapper>{element}</Wrapper>;
}
